const YM_ACTIONS = {
    sendShortMortgage: [
        'mortgage', 'mortgage-refinancing', 'it-mortgage',
        'village', 'building', 'mortgage-children',
        'commercial-property', 'new-building',
    ],
    sendShortPotreb: ['consumer-loan', 'credit-for-all'],
    sendShortCurrencyRko: ['rko-special'],
    sendShortRko: [
        'opening-and-maintaining-account',
        'opening-and-maintaining-account-new',
        'corporate-cards', 'rko-currency',
    ],
    sendShortAcquiring: ['acquiring'],
    sendShortCarLoan: ['car-loans'],
    sendShortRefinance: ['refinancing'],
    sendShortItMortgage: ['it-mortgage'],
    sendDepositCallback: [
        'deposits', 'urgent', 'cumulative',
        'irreducible', 'marketplace', 'placement-of-funds-and-securities',
    ],
    sendShortMaternalCapital: ['maternal-capital'],
    sendPromotions: ['online-cashbox-free'],
};

const TMR_ACTIONS = {
    AutoLead: ['car-loans'],
    PotrebLead: ['consumer-loan', 'credit-for-all'],
    RefinanceLead: ['refinancing'],
    IpotekaLead: [
        'mortgage', 'mortgage-refinancing', 'it-mortgage',
        'village', 'building', 'mortgage-children',
        'commercial-property', 'new-building', 'mortgage-neometry',
        'green-mortgage', 'mortgage-combo', 'bank-programm', 'large-family',
        'mortgage-gc-a101', 'mortgage-gc-pioneer', 'maternal-capital',
    ],
    RKOlead: [
        'rko-special', 'opening-and-maintaining-account',
        'opening-and-maintaining-account-new', 'web-tsp',
        'acquiring', 'payment-qr', 'internet-acquiring',
        'corporate-cards', 'rko-currency', 'online-cashbox-free',
    ],
    BusinessLead: [
        'salary-projects', 'placement-of-funds-and-securities',
        'resort-acquiring', 'self-employed',
    ],
};

export {
    YM_ACTIONS,
    TMR_ACTIONS,
};
